import { BenefitStartDateValues } from 'core/application/adminDashboard/benefitDetails/design/common/models'
import { PerksBenefitDesignStateValues } from 'core/application/adminDashboard/benefitDetails/perks/benefitDesignState'
import { WizardStatus } from 'core/domain/wizard/wizard'

import { NavItemProps } from '../common/models'
import PerksBenefitStartDate from './benefitStartDate'
import PerksEmployeeClasses, { PerksEmployeeClassesProps } from './employeeClasses'
import PerksFinishBenefitDesign, { PerksFinishBenefitDesignProps } from './finishBenefitDesign'

export enum BenefitDesignStep {
  BenefitStartDate = 'perks-benefit-start-date',
  EmployeeClasses = 'perks-benefit-class-selection',
  FinishBenefitDesign = 'perks-benefit-design-class-benefits',
}

export const NavItemsMapping: NavItemProps[] = [
  {
    key: BenefitDesignStep.BenefitStartDate,
    component: PerksBenefitStartDate,
    nextButtonTooltip: 'admin-dashboard.benefit-details.benefit-start-date.next-tooltip',
    mapState: (state: PerksBenefitDesignStateValues | undefined): BenefitStartDateValues | undefined => {
      return state
        ? {
            benefitStartDate: state.benefitStartDate,
            planPeriodId: state ? state.planPeriodId : '',
          }
        : undefined
    },
  },
  {
    key: BenefitDesignStep.EmployeeClasses,
    component: PerksEmployeeClasses,
    nextButtonTooltip: 'admin-dashboard.benefit-details.perks-benefit-create-eligible-classes.next-tooltip',
    mapState: (state: PerksBenefitDesignStateValues | undefined): PerksEmployeeClassesProps => {
      return {
        planPeriodId: state ? state.planPeriodId : '',
      }
    },
  },
  {
    key: BenefitDesignStep.FinishBenefitDesign,
    component: PerksFinishBenefitDesign,
    nextButtonTooltip: 'admin-dashboard.benefit-details.perks-design-class.tooltip',
    mapState: (state: PerksBenefitDesignStateValues | undefined): PerksFinishBenefitDesignProps => {
      return {
        planPeriodId: state ? state.planPeriodId : '',
        wizardStatus: state ? state.wizardStatus : WizardStatus.InProgress,
      }
    },
  },
]

export const ReadonlyStepsWhenBenefitIsFinished: string[] = []
